
import React, { useState } from "react";
import { Box, Typography, Divider, Card, CardContent, Button, TextField, InputAdornment, Avatar } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import TopBar from "./globalComponents/topbar";
import Footer from "./globalComponents/footer";

export default function FaqPage() {
  const [search, setSearch] = useState("");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", bgcolor: "#F6F7F9", minHeight: "100vh" }}>
      <TopBar />

      {/* Main Content */}
      <Box sx={{ display: "flex", flexDirection: "row", p: 4, gap: 3, flex: 1 }}>
        
        {/* Sidebar */}
        <Card
          sx={{
            width: 350,
            borderRadius: 2,
            boxShadow: 1,
            bgcolor: "white",
            p: 3,
            height: "fit-content",
          }}
        >
          <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 600, mb: 2 }}>
            Settings
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {/* Profile Card */}
          <Card
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: 2,
              mb: 3,
              bgcolor: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
              borderRadius: 2,
              boxShadow: 1,
            }}
          >
            <Avatar
              src="https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lbz1ku6y_expires_30_days.png"
              sx={{ width: 58, height: 58 }}
            />
            <Box>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Guy Hawkins
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  bgcolor: "primary.main",
                  color: "white",
                  borderRadius: 1,
                  px: 1,
                  py: 0.2,
                  display: "inline-block",
                }}
              >
                Mentee
              </Typography>
              <Typography variant="body2" color="text.secondary">
                yourguy123@email.com
              </Typography>
            </Box>
          </Card>

          {/* Sidebar Links */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
            General Settings
          </Typography>

          {[
            "Edit Profile",
            "Change Password",
            "Language Settings",
            "Account Settings",
            "Manage Data & Permissions",
            "Notifications",
            "Help & Support",
            "FAQ",
            "Contact Us",
            "Terms of Service",
            "Privacy Policy",
            "About Us",
          ].map((item, i) => (
            <Button
              key={i}
              variant="text"
              fullWidth
              endIcon={<ArrowForwardIosIcon fontSize="small" />}
              sx={{
                justifyContent: "space-between",
                textTransform: "none",
                color: item === "FAQ" ? "primary.main" : "text.primary",
                fontWeight: item === "FAQ" ? "bold" : "normal",
                mb: 1,
              }}
            >
              {item}
            </Button>
          ))}
        </Card>

        {/* FAQ Content Area */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 3 }}>
          <Typography variant="h4" fontWeight="bold">
            FAQs
          </Typography>

          {/* Search Bar */}
          <TextField
            fullWidth
            placeholder="Search for answers..."
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{
              bgcolor: "#FAFAFA",
              borderRadius: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />

          {/* FAQ Sections */}
          <Box>
            <Typography variant="subtitle1" color="text.secondary" fontWeight="bold" mb={1}>
              General
            </Typography>
            {["What is this app about?", "Who can use this app?"].map((q, i) => (
              <Card
                key={i}
                variant="outlined"
                sx={{
                  mb: 2,
                  borderRadius: 2,
                  "&:hover": { boxShadow: 2, borderColor: "primary.main" },
                }}
              >
                <Button
                  fullWidth
                  sx={{
                    justifyContent: "space-between",
                    textTransform: "none",
                    color: "text.primary",
                    p: 2,
                    fontWeight: "bold",
                  }}
                  onClick={() => alert(q)}
                  endIcon={<ArrowForwardIosIcon />}
                >
                  {q}
                </Button>
              </Card>
            ))}
          </Box>

          <Box>
            <Typography variant="subtitle1" color="text.secondary" fontWeight="bold" mb={1}>
              Account & Security
            </Typography>
            <Card variant="outlined" sx={{ borderRadius: 2, mb: 2 }}>
              <Button
                fullWidth
                sx={{
                  justifyContent: "space-between",
                  textTransform: "none",
                  color: "text.primary",
                  p: 2,
                  fontWeight: "bold",
                }}
                endIcon={<ArrowForwardIosIcon />}
              >
                How do I reset my password?
              </Button>
            </Card>

            <Card variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
              <Typography variant="body1" fontWeight="bold" mb={1}>
                Can I change my registered email address?
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Yes, go to Settings → Account Settings → Change Email. You'll need to verify your new
                email before it's updated.
              </Typography>
            </Card>
          </Box>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
}
